import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name
})
var crud = new Crud('ProductionAreas', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  productionAreas: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  productionAreas: state => state.productionAreas
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
